import React from "react";
import '../../App.css'
import JobApp from "../JobFilter";

function Careers(){
    return (
        <>
            <h1 className="careers">JOIN DEI</h1>
            <JobApp></JobApp>
            
            

        </>
    )
}

export default Careers
